import moment from 'moment';
import Cookies from 'universal-cookie';

const postEndBreakPayload = (formData) => {
  const cookies = new Cookies();
  const timezone = cookies.get('organization')?.timezone;
  return {
    operatorBreakLogId: formData?.monitoringStatus?.break?.logId,
    endedAt: moment.tz(timezone).format('YYYY-MM-DD HH:mm:ss'),
    notes: formData?.notes,
  };
};

export default postEndBreakPayload;
